import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';

import Skeleton, {
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from '@buyside/components/presentation/Skeleton/skeleton';

import styles from './navigationNotificationsStyles.scss';

const NavigationNotificationLoading: React.FC = () => {
  return (
    <div className={styles.notification}>
      <div>
        <FontAwesomeIcon icon={faSpinner} spin />
      </div>
      <div>
        <div>
          <Skeleton width={SKELETON_WIDTHS.FULL} size={SKELETON_SIZES.SMALL} />
          <Skeleton width={SKELETON_WIDTHS.FULL} size={SKELETON_SIZES.SMALL} />
        </div>
        <div>
          <Skeleton width={SKELETON_WIDTHS.SMALL} size={SKELETON_SIZES.SMALL} />
        </div>
      </div>
    </div>
  );
};

export default NavigationNotificationLoading;
